/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type CaseTypeEnum = (typeof CaseTypeEnum)[keyof typeof CaseTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CaseTypeEnum = {
  Purchase: 1,
  HomeDelivery: 2,
  InternalDelivery: 3,
  Extra: 4,
  TradeIn: 5,
  FaciliyExchange: 6,
  InternalDeliverySales: 7,
  FacilityToFacility: 8,
  Verkstadsbilar: 9,
  RMOther: 11,
  Swamp: 12,
  Placeholder: 13,
  CarTransportTruck: 14,
  TestDrive: 15,
  RentedStaff: 16,
  Auction: 17,
  Samakning: 18,
  Avyttringar: 19,
  Garantiarenden: 20,
  AterTillLogistik: 21,
  FacilityTransfer: 23,
  Dackkorning: 24,
} as const;
